import React from 'react';
import { FaStar, FaRegStar, FaStarHalfStroke, FaCircleCheck, FaShieldHalved, FaArrowRight } from 'react-icons/fa6';
import './casinocard.css';

const BADGE_COLORS = ['blue', 'cyan', 'gold', 'green', 'blue', 'cyan'];

function StarRating({ rating }) {
  const full = Math.floor(rating);
  const half = rating - full >= 0.5;
  const empty = 5 - full - (half ? 1 : 0);
  return (
    <div className="rating__stars" aria-label={`Rating: ${rating} out of 5`}>
      {Array(full).fill(null).map((_, i) => (
        <FaStar key={`f${i}`} className="rating__star" size={15} />
      ))}
      {half && <FaStarHalfStroke className="rating__star" size={15} />}
      {Array(empty).fill(null).map((_, i) => (
        <FaRegStar key={`e${i}`} className="rating__star rating__star--empty" size={15} />
      ))}
    </div>
  );
}

export default function CasinoCard({ casino, featured = false, rank = null }) {
  return (
    <article className={`casino-card${featured ? ' casino-card--featured' : ''}`}>
      {featured && (
        <div className="casino-card__featured-ribbon">
          <span>Top Pick</span>
        </div>
      )}

      <div className="casino-card__header">
        {rank && (
          <div className="casino-card__rank">#{rank}</div>
        )}
        <div className="casino-card__logo-wrap">
          <img
            src={casino.logo}
            alt={`${casino.name} casino logo`}
            className="casino-card__logo"
            onError={(e) => {
              e.target.style.display = 'none';
              e.target.nextSibling.style.display = 'flex';
            }}
          />
          <div className="casino-card__logo-fallback" style={{ display: 'none' }}>
            {casino.name.charAt(0)}
          </div>
        </div>
        <div className="casino-card__meta">
          <h3 className="casino-card__name">{casino.name}</h3>
          <div className="casino-card__rating">
            <StarRating rating={casino.rating} />
            <span className="casino-card__rating-score">{casino.ratingLabel}</span>
          </div>
        </div>
      </div>

      <div className="casino-card__bonus">
        <div className="casino-card__bonus-headline">{casino.bonusHeadline}</div>
        <div className="casino-card__bonus-details">{casino.bonusDetails}</div>
      </div>

      <p className="casino-card__desc">{casino.description}</p>

      <div className="casino-card__badges">
        {casino.badges.map((badge, i) => (
          <span key={badge} className={`badge badge--${BADGE_COLORS[i % BADGE_COLORS.length]}`}>
            {badge}
          </span>
        ))}
      </div>

      <div className="casino-card__highlights">
        {casino.highlights.map((h) => (
          <div key={h} className="casino-card__highlight">
            <span className="casino-card__highlight-icon" aria-hidden="true">
              <FaCircleCheck size={16} />
            </span>
            <span>{h}</span>
          </div>
        ))}
      </div>

      <div className="casino-card__footer">
        <div className="casino-card__licence">
          <span className="casino-card__licence-icon" aria-hidden="true">
            <FaShieldHalved size={15} />
          </span>
          <span>{casino.licence} · Min deposit: {casino.minDeposit}</span>
        </div>
        <div className="casino-card__ctas">
          <a
            href={casino.affiliateLink}
            target="_blank"
            rel="noopener noreferrer sponsored"
            className={`btn btn--primary${featured ? ' btn--lg' : ''} btn--full`}
          >
            Claim Bonus
          </a>
          <a href={casino.reviewSlug} className="casino-card__review-link">
            Full review <FaArrowRight className="casino-card__review-arrow" size={12} aria-hidden />
          </a>
        </div>
        <p className="casino-card__tcs">18+ | T&amp;Cs apply | Gamble responsibly</p>
      </div>
    </article>
  );
}
